// IMPORT COMPONENTS
/*
 * Chemin relatif au fichier dans lequel on est
 * Ex : import {utils} from '../components/_utils';
 */
import { utils } from "../components/_utils";
import { Fancybox } from "@fancyapps/ui";

const bdc = {
    readyFn: function () {
        let self = this;
        self.bdcInit();
    },

    updateCart: function () {
        $("tr.product").each(function () {
            let tr = $(this);
            let quantity = parseInt($(this).find('input.product-quantity').val());
            let total_product = quantity * parseFloat($(tr).data("product-price"));
            console.log(quantity);

            $(tr).find("span.product-total-price").text(utils.number_format(total_product, 2, ",", " "));
            if (quantity > 0)
                $(tr).find("td.total").removeClass("zero");
            else
                $(tr).find("td.total").addClass("zero");
        });

        const formElement = document.getElementById("products-form");
        const formData = new FormData(formElement);
        formData.append("action", "update_cart");
        $.ajax({
            url: ajaxurl,
            type: "POST",
            data: formData,
            success: function (data) {
                data = JSON.parse(data);
                $("table#order").html(data.html);
                if (data.enable == 1) {
                    $("button#submit-order, button#make-pdf, button#empty-cart").prop("disabled", false);
                } else {
                    $("button#submit-order, button#make-pdf, button#empty-cart").prop("disabled", true);
                }
            },
            cache: false,
            contentType: false,
            processData: false,
        });
    },

    bdcInit: function () {

        Fancybox.bind("[data-fancybox]");

        $('.minus').click(function () {
            var $input = $(this).closest(".input-group").find('input.product-quantity');
            var count = parseInt($input.val()) - 1;
            count = count < 0 ? 0 : count;
            $input.val(count);
            $input.change();
            return false;
        });

        $('.plus').click(function () {
            var $input = $(this).closest(".input-group").find('input.product-quantity');
            $input.val(parseInt($input.val()) + 1);
            $input.change();
            return false;
        });

        $(document).on("change", "input.product-quantity", function () {
            bdc.updateCart();
        });

        $(document).ready(function () {
            bdc.updateCart();
        });

        $("form#order-form").on('submit', function (e) {
            e.preventDefault();
            var real_order = $("button:focus").val();
            var message = (real_order == 1) ? 'Votre commande est en cours d\'envoi ...' : 'Votre devis est en cours de création ...';
            $('#modal-loading').find(".message").html(message);
            $('#modal-loading').foundation('open');
            var real_order = $("button:focus").val();
            var formData = new FormData(this);
            formData.append("real_order", real_order);
            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: formData,
                success: function (data) {
                    $('#modal-loading').foundation('close');
                    $('#modal-confirm').find(".message").html(data);
                    $('#modal-confirm').foundation('open');
                    $('form#order-form').trigger('reset');
                },
                cache: false,
                contentType: false,
                processData: false
            });
        });

        $("#empty-cart").on("click", function (e) {
            e.preventDefault();
            if (confirm("Êtes-vous sûr de vouloir vider le panier ?")) {
                $("tr.product").each(function () {
                    let tr = $(this);
                    $(this).find('input.product-quantity').val(0);
                    $(tr).find("span.product-total-price").text(utils.number_format(0, 2, ",", " "));
                    $(tr).find("td.total").addClass("zero");
                });
                bdc.updateCart();
            }
        });
    },

};

export { bdc };
